import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import condition from './modules/condition'
import courses from './modules/courses'
import destinations from './modules/destinations'
import history from './modules/history'
import favorites from './modules/favorites'
import genres from './modules/genres'
import geolocation from './modules/geolocation'
import googleMap from './modules/googleMap'
import loading from './modules/loading'
import map from './modules/map'
import places from './modules/places'
import plans from './modules/plans'
import routes from './modules/routes'
import stations from './modules/stations'
import locations from './modules/locations'
import translation from './modules/translation'
import user from './modules/user'
import drawer from './modules/drawer'
import busstops from './modules/busstops'
import serviceAreas from './modules/serviceAreas'
import reservation from './modules/reservation'
import notice from './modules/notice'
import tickets from './modules/tickets'

Vue.use(Vuex);

const dataState = createPersistedState({
  paths: [
    'condition',
    'course',
    'destinations',
    'history',
    'genres',
    'map',
    'places',
    'plans',
    'routes',
    'stations',
    'locations',
    'translation',
    'user',
    'notice',
    'tickets'
  ],
  // NOTE: vuex-persistedstateで復元するときに日付を文字列からmomentに変換
  subscriber(store) {
    store.dispatch('condition/parseTime')
    store.dispatch('routes/parseTime')
    return function(handler) {
      return store.subscribe(handler)
    }
  }
})

const actions = {
  resetAll ({ dispatch }) {
    dispatch('condition/reset', {}, { root: true })
    dispatch('courses/reset', {}, { root: true })
    dispatch('destinations/reset', {}, { root: true })
    dispatch('favorites/reset', {}, { root: true })
    dispatch('genres/reset', {}, { root: true })
    dispatch('geolocation/reset', {}, { root: true })
    dispatch('googleMap/reset', {}, { root: true })
    dispatch('history/reset', {}, { root: true })
    dispatch('map/reset', {}, { root: true })
    dispatch('places/reset', {}, { root: true })
    dispatch('plans/reset', {}, { root: true })
    dispatch('routes/reset', {}, { root: true })
    dispatch('stations/reset', {}, { root: true })
    dispatch('locations/reset', {}, { root: true })
    dispatch('translation/reset', {}, { root: true })
    dispatch('user/reset', {}, { root: true })
    dispatch('notice/reset', {}, { root: true })
    dispatch('tickets/reset', {}, { root: true})
  }
}

const store = new Vuex.Store({
  actions,
  plugins: [dataState],
  modules: {
    condition,
    courses,
    destinations,
    favorites,
    genres,
    geolocation,
    googleMap,
    history,
    loading,
    map,
    places,
    plans,
    routes,
    stations,
    locations,
    translation,
    user,
    notice,
    tickets,
    drawer,
    busstops,
    serviceAreas,
    reservation
  }
})

export default store
